import { defineMessages } from 'react-intl'

export const locale = defineMessages({
  findEvents: {
    id: 'navbar.find_events',
    defaultMessage: 'Find Events',
  },
  createEvent: {
    id: 'navbar.create_event',
    defaultMessage: 'Create Event',
  },
  help: {
    id: 'navbar.help',
    defaultMessage: 'Help',
  },
  logIn: {
    id: 'navbar.sign_in',
    defaultMessage: 'Log In',
  },
  signUp: {
    id: 'navbar.sign_up',
    defaultMessage: 'Sign Up',
  },
  hostEvents: {
    id: 'navbar.host_events',
    defaultMessage: 'Host Events',
  },
  dashboard: {
    id: 'navbar.dashboard',
    defaultMessage: 'Dashboard',
  },
  eventsYouAreHosting: {
    id: 'navbar.events_youre_hosting',
    defaultMessage: 'My Events',
  },
  myTickets: {
    id: 'navbar.my_tickets',
    defaultMessage: 'My Tickets',
  },
  profile: {
    id: 'navbar.profile',
    defaultMessage: 'Profile',
  },
  messages: {
    id: 'navbar.messages',
    defaultMessage: 'Messages',
  },
  settings: {
    id: 'navbar.settings',
    defaultMessage: 'Settings',
  },
  logOut: {
    id: 'navbar.sign_out',
    defaultMessage: 'Log Out',
  },
  features: {
    id: 'navbar.feature',
    defaultMessage: 'Features',
  },
  customers: {
    id: 'navbar.customers',
    defaultMessage: 'Customers',
  },
  pricing: {
    id: 'navbar.pricing',
    defaultMessage: 'Pricing',
  },
  helpCenter: {
    id: 'navbar.helpCenter',
    defaultMessage: 'Help Center',
  },
  cantFindTickets: {
    id: 'navbar.cantFindTickets',
    defaultMessage: 'Where are my tickets?',
  },
  contactOrganizer: {
    id: 'navbar.contactOrganizer',
    defaultMessage: 'Contact the event organizer',
  },
  canRefund: {
    id: 'navbar.canRefund',
    defaultMessage: 'Can I get a refund?',
  },
  searchEvents: {
    id: 'navbar.searchEvents',
    defaultMessage: 'Search for events',
  },
  linkToHomePage: {
    id: 'navbar.linkToHomePage',
    defaultMessage: 'link to universe homepage',
  },
})
